<ng-template #tollsData let-header="header" let-tolls="tolls">
  <h5>{{header | translate}}:</h5>
  <p *ngFor="let toll of (tolls)">
    <strong>{{toll.country}}:</strong> {{toll.amountInTargetCurrency | price}}
  </p>
</ng-template>
<ng-template #countriesData let-header="header" let-countries="countries">
  <h5>{{header | translate}}:</h5>
  <p *ngFor="let item of (countries)">
    <strong>{{item.country}}:</strong> {{item.distance | distance}}
  </p>
</ng-template>
<ng-template #addFullTankTip>
  {{'proTasks.form.addFullTank' | translate}}
</ng-template>
<ng-template #deleteTankTip>
  {{'proTasks.form.deleteTank' | translate}}
</ng-template>
<ng-template #pricesDataTooltip let-header="header" let-prices="prices">
  <div class="task-form__price-tooltip">
    <h5>{{header | translate}}:</h5>
    <p>{{'proTasks.routeCost.fuel' | translate}}: <strong>{{prices.fuelPrice | price}}</strong></p>
    <p>{{'proTasks.routeCost.operatingCost' | translate}}: <strong>{{prices.operatingCost | price}}</strong></p>
    <p>{{'proTasks.routeCost.roadsTolls' | translate}}: <strong>{{prices.roadsTolls | price}}</strong></p>
    <p>{{'proTasks.routeCost.markedRoadsTolls' | translate}}: <strong>{{prices.markedRoadsTolls | price}}</strong></p>
  </div>
</ng-template>
<div class="task-form__container"
     [ngClass]="{'task-form__container--map': mapActive, 'task-form__container--form': taskFormActive, 'task-form__container--properties': tabsActive}">
  <section class="task-list--current" *ngIf="!isMobile">
    <header class="task-list__header">
      <h2>{{'proTasks.form.present' | translate}}</h2>
      <div class="task-totals" *ngIf="data != null">
        <dl title="{{'proTasks.current-route-distance' | translate}}">
          <dt><i class="ico-road"></i></dt>
          <dd>{{data.currentTotals.distance | distance}}</dd>
        </dl>
        <dl title="{{'proTasks.current-route-time' | translate}}">
          <dt><i class="ico-clock"></i></dt>
          <dd>{{data.currentTotals.duration | duration}}</dd>
        </dl>
        <dl title="{{'proTasks.current-co2' | translate}}">
          <dt><i class="ico-co2"></i></dt>
          <dd>{{totalCO2Emission}}</dd>
        </dl>
        <dl *ngIf="shouldShowMarkedRoadsTolls(data.currentTotals.markedRoadsTollsTotal)"
            title="{{'proTasks.marked-paid-roads-tolls' | translate}}">
          <dt><i class="ico-road"></i></dt>
          <dd>{{data.currentTotals.markedRoadsTollsTotal | price}}</dd>
        </dl>
        <dl class="hover-tooltip" id="price-tooltip">
          <dt><i class="ico-money"></i></dt>
          <dd>{{data.currentTotals.tolls?.totalCost | price}}
            <div class="hover-tooltip__content">
              <ng-container *ngTemplateOutlet="
              tollsData;
              context: {
              'header': 'route.map.toll-prices',
              'tolls': data.currentTotals.tolls?.countryTolls}"></ng-container>
            </div>
          </dd>
        </dl>
        <dl title="{{'proTasks.current-route-cost' | translate}}" *ngIf="currentRouteCost?.totalPrice != null">
          <dt><i class="ico-coin"></i></dt>
          <dd>{{currentRouteCost.totalPrice | price}}</dd>
        </dl>
      </div>
    </header>
    <div class="task-list__content" *ngIf="data != null">
      <div *ngFor="let task of data.currentTasks; let idx = index">
        <article class="task-point">
          <header title="{{'proTasks.type.' + task.type | translate}}"
                  class="task-point__status task-point__sts--{{task.status}}">
            <i class="ico-{{task.type}} sz-m"></i>
          </header>
          <div class="task-point__details">
            <div title="{{'proTasks.form.address' | translate}}" class="task-point__address">
              <i class="ico-location"></i>
              {{getAddressText(task)}}
            </div>
            <div class="task-totals">
              <dl class="distance" title="{{'proTasks.form.distance' | translate}}">
                <dt><i class="ico-road"></i></dt>
                <dd>{{task.distance | distance}}</dd>
              </dl>
              <dl class="duration" title="{{'proTasks.form.duration' | translate}}">
                <dt><i class="ico-clock"></i></dt>
                <dd>{{task.duration | duration}}</dd>
              </dl>
              <dl *ngIf="shouldShowMarkedRoadsTolls(task.markedRoadsTolls)"
                  title="{{'proTasks.marked-paid-roads-tolls' | translate}}">
                <dt><i class="ico-road"></i></dt>
                <dd>{{task.markedRoadsTolls | price}}</dd>
              </dl>
              <dl class="hover-tooltip" *ngIf="task.tolls">
                <dt><i class="ico-money"></i></dt>
                <dd>{{task.tolls?.totalCost | price}}
                  <div class="hover-tooltip__content">
                    <ng-container *ngTemplateOutlet="
                    tollsData;
                    context: {
                    'header': 'route.map.toll-prices',
                    'tolls': task.tolls?.countryTolls}"></ng-container>
                  </div>
                </dd>
              </dl>
              <dl title="{{'proTasks.task-route-cost' | translate}}"
                  *ngIf="eachTaskRouteCost[idx] != null">
                <dt><i class="ico-coin"></i></dt>
                <dd>{{eachTaskRouteCost[idx].totalPrice | price}}</dd>
              </dl>
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>
  <section class="task-list--plan" *ngIf="!isMobile || taskFormActive">
    <header class="task-list__header">
      <h2>{{'proTasks.form.planning' | translate}}</h2>
      <nav class="task-list__actions">
        <a class="item__action--alert"
           *ngIf="!forbiddenManageTasks"
           [ngClass]="{'disabled': !areFormsValid()}"
           (click)="save(true)"
           title="{{'proTasks.form.save-confirm' | translate}}">
          <i class="ico-send"></i>
        </a>
        <a class="item__action--primary"
           *ngIf="!forbiddenManageTasks"
           [ngClass]="{'disabled': !areFormsValid()}"
           (click)="save(false)"
           title="{{'proTasks.form.save' | translate}}">
          <i class="ico-save"></i>
        </a>
        <a class="item__action--danger"
           (click)="cancel()"
           title="{{'proTasks.form.cancel' | translate}}">
          <i class="ico-close sz-xs"></i>
        </a>
      </nav>
      <div class="task-totals">
        <dl title="{{'proTasks.current-route-distance' | translate}}">
          <dt><i class="ico-globe"></i></dt>
          <dd>{{planningTotalDistance | distance}}</dd>
        </dl>
        <dl class="hover-tooltip">
          <dt><i class="ico-road"></i></dt>
          <dd>{{activeForm?.controls.distance.value | distance}}
            <div class="hover-tooltip__content">
              <ng-container *ngTemplateOutlet="
              countriesData;
              context: {
              'header': 'proTasks.planning-route-distance',
              'countries': activeForm?.controls.countries?.value}">
              </ng-container>
            </div>
          </dd>
        </dl>
        <dl title="{{'proTasks.planning-route-time' | translate}}">
          <dt><i class="ico-clock"></i></dt>
          <dd>{{activeForm?.controls.duration.value | duration}}</dd>
        </dl>
        <dl title="{{'proTasks.planning-co2' | translate}}">
          <dt><i class="ico-co2"></i></dt>
          <dd>{{activeRouteCO2Emission}}</dd>
        </dl>
        <dl *ngIf="shouldShowMarkedRoadsTolls(activeForm?.controls.markedRoadsTolls?.value)"
            title="{{'proTasks.marked-paid-roads-tolls' | translate}}">
          <dt><i class="ico-road"></i></dt>
          <dd>{{activeForm?.controls.markedRoadsTolls?.value | price}}</dd>
        </dl>
        <dl class="hover-tooltip">
          <dt><i class="ico-money"></i></dt>
          <dd>{{activeForm?.controls.tolls?.value?.totalCost | price}}
            <div class="hover-tooltip__content">
              <ng-container *ngTemplateOutlet="
              tollsData;
              context: {
              'header': 'route.map.toll-prices',
              'tolls': activeForm?.controls.tolls?.value?.countryTolls}"></ng-container>
            </div>
          </dd>
        </dl>
        <dl class="hover-tooltip" *ngIf="planningRouteCost != null">
          <dt><i class="ico-coin"></i></dt>
          <dd>{{planningRouteCost.totalPrice | price}}
            <div class="hover-tooltip__content hover-tooltip__content--wide">
              <ng-container *ngTemplateOutlet="
              pricesDataTooltip;
              context: {
              'header': 'proTasks.routeCost.planning-route-cost',
              'prices': planningRouteCost}"></ng-container>
            </div>
          </dd>
        </dl>
      </div>
      <div class="task-totals" *ngIf="unsavedForms.length > 0">
        <dl title="{{'proTasks.unsavedRouteDistance' | translate}}">
          <dt><i class="ico-road"></i></dt>
          <dd>{{unsavedFormsTotalDistance | distance}}</dd>
        </dl>
        <dl title="{{'proTasks.unsavedRouteDuration' | translate}}">
          <dt><i class="ico-clock"></i></dt>
          <dd>{{unsavedFormsDuration | duration}}</dd>
        </dl>
        <dl title="{{'proTasks.unsavedRouteCo2' | translate}}">
          <dt><i class="ico-co2"></i></dt>
          <dd>{{unsavedFormsCO2Emission}}</dd>
        </dl>
        <dl class="hover-tooltip">
          <dt><i class="ico-money"></i></dt>
          <dd>{{unsavedFormsTolls | price}}
            <div class="hover-tooltip__content">
              <ng-container *ngTemplateOutlet="
              tollsData;
              context: {
              'header': 'route.map.toll-prices',
              'tolls': unsavedFormsCountryTolls}"></ng-container>
            </div>
          </dd>
        </dl>
        <dl class="hover-tooltip" *ngIf="unsavedTasksRouteCost != null">
          <dt><i class="ico-coin"></i></dt>
          <dd>
            {{unsavedTasksRouteCost.totalPrice | price}}
            <div class="hover-tooltip__content hover-tooltip__content--wide">
              <ng-container *ngTemplateOutlet="
              pricesDataTooltip;
              context: {
              'header': 'proTasks.unsavedRouteCost',
              'prices': unsavedTasksRouteCost}"></ng-container>
            </div>
          </dd>
        </dl>
        <dl *ngIf="traveledDistance >= 0 && activeForm.value.distance > 0 && !routeReloading"
            title="{{'proTasks.remainingDistance' | translate}}">
          <dt><i class="ico-road"></i></dt>
          <dd>{{calculateRemainingDistance() | distance}}</dd>
        </dl>
      </div>
    </header>
    <div class="task-list__content" *ngIf="activeForm != null" id="planning">
      <form [formGroup]="forms[0]" *ngIf="forms[0]" class="origin-point">
        <div class="origin-point__icon">
          <i [ngClass]="useLastTripCoords ? 'ico-location' : 'ico-target'"></i>
        </div>
        <input type="text"
               placeholder="{{'proTasks.form.origin-point' | translate}}"
               maxlength="255"
               formControlName="origin"
               class="origin-point__input"
               [ngClass]="{'not-valid': notValid(forms[0]?.controls.origin)}"
               (focus)="activateForm(forms[0]?.controls.idx.value, $event, 0, false, 'ORIGIN')"
               (paste)="activateForm(forms[0]?.controls.idx.value, $event, 0, true, 'ORIGIN')"
               appInputModified (modifiedKeydown)="onKeyUp($event, activeType, forms[0]?.controls.idx.value)"
               appAutocompleteOff/>
        <div class="task-autocomplete">
          <div class="task-autocomplete__item autocomplete__item--{{index}}"
               [ngClass]="{'poi-bold': result.important && result.source !== null}"
               *ngFor="let result of searchResult[forms[0]?.controls.idx.value];  let index = index"
               (click)="onChangeValue(result, activeType, forms[0]?.controls.idx.value)">
            {{result.name}}
            <input type="hidden" value="{{result.name}}"></div>
          <div id="show-more-0" class="show-more hidden" (click)="showMore(0, $event)">
            {{'proTasks.form.showMore' | translate}}
          </div>
        </div>
        <div class="origin-point__action">
          <a class="origin-point__button"
             (click)="toggleLastTrip()">
            <i class="ico-location-arrow"></i>
          </a>
        </div>
      </form>
      <div cdkDropList (cdkDropListDropped)="drop($event)">
        <div *ngFor="let form of forms" cdkDrag cdkDragLockAxis="y">
          <form [formGroup]="form">
            <div class="task-point input-group address-input"
                 [ngClass]="{
                 'task-point--active': (activeFormIdx === form.controls.idx.value),
                 'task-point--suggestion': (suggestionTaskUuids.includes(form.controls?.uuid?.value))}">
                 <!-- and class task-point--suggestion for AI suggestions -->
              <div class="task-point__status task-point__sts--{{form.controls.status.value}}"
                   (click)="activateForm(form.controls.idx.value, $event, form.controls.idx.value + 1, false, activeType)">
                <div class="letter">{{alphabet[form.controls.idx.value]}}</div>
                <i class="ico-{{form.controls.type.value}} sz-s"></i>
              </div>
              <select formControlName="type"
                class="task-point__input form-control form-control-sm"
                [ngClass]="{'not-valid': notValid(form.controls.type)}"
                (change)="formRouteInfo(activeForm, true)"
                (focus)="activateForm(form.controls.idx.value, $event, form.controls.idx.value + 1, false, 'ORIGIN')">
                <option *ngIf="typeInConfigs(form.value.type)"
                        [value]="null" disabled selected>{{'proTasks.type.title' | translate}}</option>
                <option *ngIf="!typeInConfigs(form.value.type)"
                        [value]="form.value.type" disabled selected>{{getDropdownDefaultSelectName(form.value.type)}}</option>
                <option *ngFor="let type of taskTypes" [value]="type">
                  {{'proTasks.type.' + type | translate}}
                </option>
              </select>
              <input type="text"
                     id="form-origin-{{form.controls.idx.value}}"
                     placeholder="{{'proTasks.form.origin-point' | translate}}"
                     maxlength="255"
                     formControlName="origin"
                     class="task-point__input form-control hidden"
                     [ngClass]="{'not-valid': notValid(form.controls.origin)}"
                     (focus)="activateForm(form.controls.idx.value, $event, form.controls.idx.value + 1, false, 'ORIGIN')"
                     (paste)="activateForm(form.controls.idx.value, $event, form.controls.idx.value + 1, true, 'ORIGIN')"
                     appInputModified (modifiedKeydown)="onKeyUp($event, activeType, form.controls.idx.value + 1)"
                     appAutocompleteOff/>
              <input type="text"
                     placeholder="{{'proTasks.form.end-point' | translate}}"
                     maxlength="255"
                     formControlName="destination"
                     class="task-point__input form-control"
                     [ngClass]="{'not-valid': notValid(form.controls.destination)}"
                     (focus)="activateForm(form.controls.idx.value, $event, form.controls.idx.value + 1, false, 'DESTINATION')"
                     (paste)="activateForm(form.controls.idx.value, $event, form.controls.idx.value + 1, true, 'DESTINATION')"
                     appInputModified (modifiedKeydown)="onKeyUp($event, activeType, form.controls.idx.value + 1)"
                     appAutocompleteOff/>
              <div class="task-autocomplete">
                <div class="task-autocomplete__item task-autocomplete__item--{{index}}"
                     [ngClass]="{'poi-bold': result.important && result.source !== null}"
                     *ngFor="let result of searchResult[form.controls.idx.value + 1];  let index = index"
                     (click)="onChangeValue(result, activeType, form.controls.idx.value + 1)">
                  {{result.name}}
                  <input type="hidden" value="{{result.name}}"></div>
                <div id="show-more-{{form.controls.idx.value + 1}}" class="show-more hidden"
                     (click)="showMore(form.controls.idx.value + 1, $event)">
                  {{'proTasks.form.showMore' | translate}}
                </div>
              </div>
              <div class="task-point__actions">
              <a *ngIf="activeForm.value.idx == form.controls.idx.value
                 && activeForm.value.destinationPosition?.lat != null
                 && activeForm.value.destinationPosition?.lng != null"
                 class="task-point__action"
                 (click)="quickPoiAdd()"
                 title="{{'proTasks.form.quickPoi' | translate}}"
                 tabindex="1">
                <i class="ico-location"></i>
              </a>
              <a *ngIf="activeForm.value.idx == form.controls.idx.value"
                 class="task-point__action"
                 (click)="copyToClipboard()"
                 tabindex="2">
                <i class="ico-copy"></i>
              </a>

              <a *ngIf="activeFormIdx === form.controls.idx.value && form.controls.waypoints.value.length > 0"
                   class="task-point__action remove-all-waypoints"
                   title="{{'proTasks.form.remove-all-waypoints' | translate}}"
                   (click)="removeFormWaypoints(form)"
                   tabindex="6">
                <i class="ico-remove-locations sz-s"></i>
              </a>
              <a *ngIf="form.controls.parkingId.value != null && form.controls.parkingType.value != null"
                 class="task-point__action"
                 title="{{'proTasks.form.parkingBooking' | translate}}"
                 (click)="parkingBooking(form)"
                 tabindex="7">
                <i class="ico-parking sz-s"
                   [ngClass]="{'has-parking-booking' : form.controls.bookingId.value != null}">
                </i>
              </a>
              <a *ngIf="form.controls.status.value === 'TODO'"
                 class="task-point__action"
                 title="{{'proTasks.form.reset-status' | translate}}"
                 (click)="resetFormStatus(form)"
                 tabindex="8">
                <i class="ico-undo"></i>
              </a>
              <a *ngIf="forms.length > 1 && form.controls.bookingId.value != null"
                 class="task-point__action"
                 [message]="'proTasks.bookingExists'"
                 (appCustomConfirm)="delete(form)"
                 tabindex="3">
                <i class="ico-trash"></i>
              </a>
              <a *ngIf="forms.length > 1 && form.controls.bookingId.value == null"
                 class="task-point__action"
                 [ngClass]="{'disabled': routeReloading}"
                 (click)="delete(form)"
                 tabindex="4">
                <i class="ico-trash"></i>
              </a>
              <a *ngIf="forms.length <= 1"
                 class="task-point__action"
                 tabindex="5">
                <i class="ico-trash disabled"></i>
              </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="task-list__add">
      <a title="{{'proTasks.form.add' | translate}}"
         *ngIf="(aiSmartRouting || fuellingModule) && !isAutomaticReplanning"
         (click)="suggestPlan(true)"
         class="item__action--tertiary task-list__ai-suggestions">
        <i class="ico-ai"></i>
        <span *ngIf="!isMobile">{{'proTasks.form.ai-suggestions' | translate}}</span>
      </a>
      <a title="{{'proTasks.form.add' | translate}}"
         *ngIf="!forbiddenManageTasks"
         (click)="addTask()"
         class="item__action--tertiary">
        <i class="ico-plus"></i>
        {{'proTasks.form.add' | translate}}
      </a>
    </div>
  </section>
  <section class="task-form" *ngIf="!isMobile || taskFormActive">
    <ng-container *ngIf="activeForm != null">
      <form [formGroup]="activeForm" class="task-form__form">
        <div class="task-form__form--main">
          <div class="input-group">
            <div class="input-group-prepend input-icon">
              <i class="ico-chat-bubble"></i>
            </div>
            <textarea class="form-control comments"
                      formControlName="comments"
                      placeholder="{{'proTasks.form.comments' | translate}}"></textarea>
          </div>
          <div class="route-info-wrapper input-group">
            <div class="input-group-prepend input-icon">
              <i class="ico-road"></i>
            </div>
            <textarea class="form-control route-info"
                      formControlName="routeInfo"
                      placeholder="{{'proTasks.form.routeInfo' | translate}}"></textarea>
          </div>
          <div class="send-message">
            <label class="custom-control custom-checkbox">
              <input class="custom-control-input checkbox-primary"
                     type="checkbox"
                     formControlName="sendMessage">
              <span class="custom-control-indicator checkbox-indicator"></span>
              <span class="custom-control-description">{{'proTasks.form.message-send' | translate}} <i
                class="ico-comment"></i></span>
            </label>
          </div>
          <div class="send-message">
            <label class="custom-control custom-checkbox">
              <input class="custom-control-input checkbox-primary"
                     type="checkbox"
                     formControlName="emptyDistance">
              <span class="custom-control-indicator checkbox-indicator"></span>
              <span class="custom-control-description">{{'proTasks.form.emptyDistance' | translate}}</span>
            </label>
          </div>
          <div class="send-message" [ngbTooltip]="'proTasks.form.hideTaskUpdatedNotificationTooltip' | translate">
            <label class="custom-control custom-checkbox">
              <input class="custom-control-input checkbox-primary"
                     type="checkbox"
                     formControlName="hideTaskUpdatedNotification">
              <span class="custom-control-indicator checkbox-indicator"></span>
              <span class="custom-control-description">{{'proTasks.form.hideTaskUpdatedNotification' | translate}}</span>
            </label>
          </div>
        </div>
        <div class="task-form__form--additional">
          <div class="additional-input input-group">
            <div class="input-group-prepend"
                 [ngClass]="{'no-border': 1 % 2}">
              <i class="ico-hourglass-full"></i>
            </div>
            <app-date-time-picker id="timeFrom"
                                  class="input-after-addon"
                                  [pickerType]="'DATE_TIME'"
                                  [placement]="'top'"
                                  [form]="activeForm"
                                  [controlName]="'timeFrom'"
                                  [placeHolder]="'proTasks.form.timeFrom' | translate">
            </app-date-time-picker>
          </div>
          <div class="additional-input input-group">
            <div class="input-group-prepend"
                 [ngClass]="{'no-border': 1 % 2, 'not-valid': notValid(activeForm.controls.timeTill)}">
              <i class="ico-hourglass-empty"></i>
            </div>
            <app-date-time-picker id="timeTill"
                                  class="input-after-addon"
                                  [pickerType]="'DATE_TIME'"
                                  [placement]="'top'"
                                  [form]="activeForm"
                                  [controlName]="'timeTill'"
                                  [placeHolder]="'proTasks.form.timeTill' | translate">
            </app-date-time-picker>
          </div>
          <div class="additional-input input-group">
            <div class="input-group-prepend"
                 [ngClass]="{'no-border': 1 % 2, 'not-valid': notValid(activeForm.controls.zoneId)}">
              <i class="ico-globe"></i>
            </div>
            <select class="form-control"
                    [ngClass]="{'narrow': false}"
                    formControlName="zoneId"
                    id="zoneId">
              <option [value]="null" selected hidden>{{'proTasks.form.zoneId' | translate}}</option>
              <option *ngFor="let zone of zones" value="{{zone}}">
                {{'zone.' + zone | translate}}
              </option>
            </select>
          </div>
          <div class="additional-input input-group">
            <div class="input-group-prepend"
                 [ngClass]="{'no-border': 1 % 2}">
              <i class="ico-clock"></i>
            </div>
            <input class="form-control"
                   type="number"
                   formControlName="durationItself"
                   [ngClass]="{'no-border': 1 % 2, 'not-valid': false}"
                   placeholder="{{'proTasks.form.durationItself' | translate}}">
          </div>
          <div class="additional-input input-group">
            <div class="input-group-prepend"
                 [ngClass]="{'no-border': 1 % 2}">
              <i class="ico-hashtag"></i>
            </div>
            <input type="text"
                   class="form-control"
                   formControlName="orderNumber"
                   [ngClass]="{'no-border': 1 % 2, 'not-valid': false}"
                   placeholder="{{'proTasks.form.orderNumber' | translate}}"
                   [readonly]="activeForm.controls.orderId.value != null">
          </div>
          <ng-container formArrayName="additionalInfo" *ngIf="getAdditionalOptions(activeForm).length > 0">
            <ng-container *ngFor="let option of getAdditionalOptions(activeForm).controls, let idx = index">
              <ng-container *ngIf="option.value.type === 'STRING'
                 && (additionalInfoConfigs.includes(option.value.optionId) || option.value.value != null)">
                <div class="additional-input input-group" [formGroupName]="idx">
                  <div class="input-group-prepend"
                       [ngClass]="{'no-border': idx % 2}">
                    <i class="fa fa-{{getIcon(option)}}"></i>
                  </div>
                  <input type="text"
                         formControlName="value"
                         class="form-control"
                         [ngClass]="{'no-border': idx % 2, 'not-valid': notValid(option.controls.value)}"
                         placeholder="{{getPlaceHolder(option.value.optionId)}}">
                </div>
              </ng-container>
              <ng-container *ngIf="option.value.type && option.value.type.includes('ENUM')
                            && (additionalInfoConfigs.includes(option.value.optionId) || option.value.value != null)">
                <div class="additional-input input-group" [formGroupName]="idx">
                  <div class="input-group-prepend"
                       [ngClass]="{'no-border': idx % 2}">
                    <i class="fa fa-{{getIcon(option)}}"></i>
                  </div>
                  <select formControlName="value"
                          class="form-control"
                          [ngClass]="{'no-border': idx % 2, 'not-valid': notValid(option.controls.value)}">
                    <option [value]="null" selected hidden>{{getPlaceHolder(option.value.optionId)}}</option>
                    <option *ngFor="let type of getEnumTypes(option.value.type)" [value]="type">
                      {{'proTasks.form.' + option.value.type + '.' + type | translate}}
                    </option>
                  </select>
                </div>
              </ng-container>
              <ng-container *ngIf="option.value.type === 'LONG'
                && (additionalInfoConfigs.includes(option.value.optionId) || option.value.value != null)">
                <div class="additional-input input-group" [formGroupName]="idx">
                  <div class="input-group-prepend">
                    <i class="fa fa-{{getIcon(option)}}"></i>
                  </div>
                  <input type="number"
                         formControlName="value"
                         placeholder="{{getPlaceHolder(option.value.optionId)}}"
                         id="{{option.value.optionId}}-TANK"
                         (change)="checkAndTriggerFuelChange(option.value)"
                         class="form-control"
                         [ngClass]="{'no-border': idx % 2, 'not-valid': notValid(option.controls.value)}">
                  <div *ngIf="(option.value.optionId === -5 || option.value.optionId === -6)
                              && activeForm.controls.type.value === 'FUELLING'
                              && option.value.value == -1"
                       class="full-tank-warning">
                    <span>{{'proTasks.form.full-tank-warning' | translate}}</span>
                  </div>
                  <div class="input-group-append fuelling-button"
                       *ngIf="(option.value.optionId === -5 || option.value.optionId === -6)
                                && activeForm.controls.type.value === 'FUELLING'">
                    <a *ngIf="option.value.value == null"
                       [ngbTooltip]="addFullTankTip"
                       (click)="addFullTank(option.value.optionId)">
                      <i class="ico-fuel"></i>
                    </a>
                    <a *ngIf="option.value.value != null"
                       [ngbTooltip]="deleteTankTip"
                       (click)="deleteTank(option.value.optionId)">
                      <i class="ico-trash"></i>
                    </a>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="option.value.type === 'DATE_TIME'
               && (additionalInfoConfigs.includes(option.value.optionId) || option.value.value != null)">
                <div class="additional-input time" [formGroupName]="idx">
                  <app-date-time-picker id="time-picker"
                                        [pickerType]="'DATE_TIME'"
                                        [placement]="'right'"
                                        [form]="getAdditionalOptions(activeForm).at(idx)"
                                        [controlName]="'value'"
                                        [placeHolder]="getPlaceHolder(option.value.optionId)"
                                        [autoSetTime]="false"
                                        [validationEnabled]="false"
                                        [setDefaultTime]="false"
                                        [narrow]="true">
                  </app-date-time-picker>
                </div>
              </ng-container>
              <ng-container *ngIf="option.value.type === 'BOOLEAN'">
                <div class="additional-input">
                  <div>
                    <i class="fa fa-{{getIcon(option)}}"></i>
                  </div>
                  <input type="text"
                         class="form-control"
                         [ngClass]="{'no-border': idx % 2}"
                         readonly
                         value="{{getPlaceHolder(option.value.optionId)}}">
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
          <div class="additional-input task-file">
            <label>
                <span class="input-group-prepend">
                  <i class="ico-paperclip"></i>
                </span>
              <input type="file" accept=".pdf,.txt,image/*" (change)="fileChange($event)"/>
              <span class="task-file__file" *ngIf="activeForm.controls.fileName.value == null">
                <span>{{'proTasks.form.attach-file' | translate}}</span>
              </span>
              <span class="task-file__file-name" *ngIf="activeForm.controls.fileName.value != null">
                <span>{{activeForm.controls.fileName.value}}</span>
              </span>
            </label>
            <a class="input-group-append"
               tabindex="10"
               *ngIf="activeForm.controls.fileName.value != null"
               (click)="removeFile()">
              <i class="ico-trash"></i>
            </a>
          </div>
        </div>
      </form>
    </ng-container>
  </section>
  <section class="task-params">
    <div class="properties" [hidden]="routePlannerActive">
      <nav class="pane__tabs">
        <a class="tab-item properties-tab" [ngClass]="{'active': routeParamsActive}" (click)="activateRouteParams()">
          <i class="ico-sliders hidden-sm-up"></i>
          <span class="hidden-sm-down">{{'proTasks.form.properties.routeParams.tabTitle' | translate}}</span>
        </a>
        <a class="tab-item properties-tab"
           [ngClass]="{'active': fuellingActive}"
           (click)="activateFuelling()">
          <i class="ico-fuel hidden-sm-up"></i>
          <span class="hidden-sm-down">{{'proTasks.form.properties.fuelling' | translate}}</span>
          <i *ngIf="fuelWarning"
             class="ico-attention-triangle an-pulse fuel-warning-active"
             [ngbTooltip]="fuelWarningMessage"></i>
        </a>
        <a class="tab-item properties-tab" [ngClass]="{'active': parkingsActive}" (click)="activateParkings()">
          <i class="ico-parking hidden-sm-up"></i>
          <span class="hidden-sm-down">{{'proTasks.form.properties.parkings' | translate}}</span>
        </a>
        <a class="tab-item properties-tab" [ngClass]="{'active': templatesActive}" (click)="activateTemplates()">
          <i class="ico-documents-exchange hidden-sm-up"></i>
          <span class="hidden-sm-down">{{'proTasks.form.properties.templates' | translate}}</span>
        </a>
        <a class="tab-item properties-tab" [ngClass]="{'active': formsActive}" (click)="activateForms()">
          <i class="ico-doc-check hidden-sm-up"></i>
          <span class="hidden-sm-down">{{'proTasks.form.properties.forms' | translate}}</span>
        </a>
      </nav>
      <div class="tab-item properties-body">
        <ng-container *ngIf="activeForm">
          <app-route-params [hidden]="!routeParamsActive"
                            [activeForm]="activeForm"
                            [vehicle]="vehicle">
          </app-route-params>
        </ng-container>
        <app-templates *ngIf="activeForm && templatesActive"
                       [activeForm]="activeForm"
                       [allForms]="forms"></app-templates>
        <app-fuel-chart *ngIf="fuellingActive && forms.length > 0 && data?.vehicle"
                        [forms]="forms"
                        [activeForm]="activeForm"
                        [vehicle]="data.vehicle"
                        [fuelCapacity]="data.vehicle.fuelTankCapacity"
                        [currentFuel]="data.vehicle.fuel"
                        [fuelUsageFor100km]="fuelUsageFor100km"
                        [fuelType]="fuelType"
                        [adBlueTankCapacity]="data.vehicle.adBlueTankCapacity"
                        [adBlueLevelPercent]="data.vehicle.adblueLevelPercent"
                        [traveledDistance]="traveledDistance">
        </app-fuel-chart>
        <app-parkings *ngIf="parkingsActive && forms.length > 0 && data?.vehicle"
                      [forms]="forms"
                      [vehicle]="data.vehicle">
        </app-parkings>
        <app-task-forms *ngIf="activeForm && formsActive" [activeForm]="activeForm"></app-task-forms>
      </div>
    </div>
    <app-ol-route id="route-details-3" class="route-details" *ngIf="routePlannerActive"></app-ol-route>
  </section>
</div>
<nav class="nav-mobile" *ngIf="isMobile && data != null">
  <a class="nav-mobile__button" [ngClass]="{'on': mapActive}" (click)="activateMap()" tabindex="1">
    <i class="ico-map-marker"></i>
  </a>
  <a class="nav-mobile__button" [ngClass]="{'on': taskFormActive}" (click)="activateTaskForm()" tabindex="2">
    <i class="ico-tasks"></i>
  </a>
  <a class="nav-mobile__button" [ngClass]="{'on': routeParamsActive}" (click)="activateTabs(); activateRouteParams()" tabindex="3">
    <i class="ico-sliders"></i>
  </a>
  <a class="nav-mobile__button" [ngClass]="{'on': fuellingActive}" (click)="activateTabs(); activateFuelling()" tabindex="4">
    <i class="ico-fuel"></i>
    <i *ngIf="fuelWarning" class="ico-attention-triangle an-pulse fuel-warning-active"></i>
  </a>
  <a class="nav-mobile__button" [ngClass]="{'on': parkingsActive}" (click)="activateTabs(); activateParkings()" tabindex="5">
    <i class="ico-parking"></i>
  </a>
  <a class="nav-mobile__button" [ngClass]="{'on': templatesActive}" (click)="activateTabs(); activateTemplates()" tabindex="6">
    <i class="ico-documents-exchange hidden-sm-up"></i>
  </a>
  <a class="nav-mobile__button" [ngClass]="{'on': formsActive}" (click)="activateTabs(); activateForms()" tabindex="7">
    <i class="ico-doc-check"></i>
  </a>
</nav>
<ng-template #fuelWarningMessage>
  {{'proTasks.form.properties.fuel.fuel-warning' | translate}}
</ng-template>
